import { NavigateFunction } from 'react-router-dom';
import { beginDealViewSwitch } from 'utils/dealSwitchView';

const dealPath = (id?: string): string => (id ? `/deal/${id}` : '/deal');

const plannerPath = (id?: string): string => (id ? `/planner/programmatic/${id}` : '/planner/programmatic');

type SwitchDealViewArgs = {
  isBlocked: boolean;
  isPlanner: boolean;
  id?: string;
  navigate: NavigateFunction;
  openModal: () => void;
};

export const switchDealView = ({ isBlocked, isPlanner, id, navigate, openModal }: SwitchDealViewArgs): void => {
  if (isBlocked) {
    openModal();
    return;
  }

  beginDealViewSwitch();
  navigate(isPlanner ? dealPath(id) : plannerPath(id));
};
